// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactIO = require("../../../../shared/src/ReactIO.bs.js");
var WebStore = require("../../store/WebStore.bs.js");
var Formality = require("re-formality/src/Formality.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactUtils = require("../../../../shared/src/ReactUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var StringUtils = require("../../../../shared/src/StringUtils.bs.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var WebTypes_View = require("../../types/WebTypes_View.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_City = require("../../../../shared/src/types/CommonTypes_City.bs.js");
var CommonTypes_Email = require("../../../../shared/src/types/CommonTypes_Email.bs.js");
var Relude_Js_Promise = require("relude/src/js/Relude_Js_Promise.bs.js");
var BrowserComponents_HR = require("../../../../shared-browser/src/components/BrowserComponents_HR.bs.js");
var Formality__Debouncer = require("re-formality/src/Formality__Debouncer.bs.js");
var CommonTypes_User_Name = require("../../../../shared/src/types/CommonTypes_User_Name.bs.js");
var WebStore_Types_Action = require("../../store/WebStore_Types_Action.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var Formality__ReactUpdate = require("re-formality/src/Formality__ReactUpdate.bs.js");
var BrowserComponents_Field = require("../../../../shared-browser/src/components/BrowserComponents_Field.bs.js");
var BrowserComponents_Input = require("../../../../shared-browser/src/components/BrowserComponents_Input.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_Dropdown = require("../../../../shared-browser/src/components/BrowserComponents_Dropdown.bs.js");
var CommonTypes_LongPhoneNumber = require("../../../../shared/src/types/CommonTypes_LongPhoneNumber.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var CommonTypes_Business_PromoCode = require("../../../../shared/src/types/business/CommonTypes_Business_PromoCode.bs.js");
var WebComponents_BusinessUnauthenticatedScreen = require("../../components/WebComponents_BusinessUnauthenticatedScreen.bs.js");

var validators_promoCode = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, _metadata) {
      return Relude_Result.ok(Curry._1(CommonTypes_Business_PromoCode.fromString, param.promoCode));
    })
};

var validators_phoneNumber = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, _metadata) {
      var partial_arg = Relude_Result.error("Invalid Phone Number");
      var partial_arg$1 = function (param) {
        return Relude_Option.fold(partial_arg, Relude_Result.ok, param);
      };
      return Relude_Option.fold(Relude_Result.error("Required"), (function (param) {
                    return Relude_Globals.$great$great(CommonTypes_LongPhoneNumber.fromString, partial_arg$1, param);
                  }), Relude_String.toNonWhitespace(StringUtils.getNumbersOnly(param.phoneNumber)));
    }),
  validateAsync: Formality__Debouncer.make(700, (function (param) {
          var dispatch = param[2];
          var value = param[0];
          var validate = function (phoneNumber, param) {
            return Relude_Js_Promise.fromIO(Relude_IO.summonError(Relude_IO.flatMap((function (isAvailable) {
                                  if (isAvailable) {
                                    return Relude_IO.pure(phoneNumber);
                                  } else {
                                    return Relude_IO.$$throw("Phone number is already in use");
                                  }
                                }), Curry._2(Relude_IO.mapError, (function (param) {
                                      return "Could not validate this phone number";
                                    }), Curry._1(param.checkIfPhoneNumberIsAvailable, phoneNumber)))));
          };
          return Formality.Async.validateAsyncWithMetadata(value, param[1], validate, (function (res) {
                        return Curry._1(dispatch, {
                                    TAG: /* ApplyAsyncResultForPhoneNumberField */8,
                                    _0: value,
                                    _1: res
                                  });
                      }));
        })),
  eq: CommonTypes_LongPhoneNumber.eq
};

var validators_password = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, _metadata) {
      return Relude_Option.fold(Relude_Result.error("Required"), Relude_Result.ok, Relude_String.toNonWhitespace(param.password));
    })
};

var validators_lastName = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, _metadata) {
      return Relude_Option.fold(Relude_Result.error("Required"), Relude_Result.ok, Curry._2(Relude_Option.flatMap, CommonTypes_User_Name.LastName.fromString, Relude_String.toNonWhitespace(param.lastName)));
    })
};

var validators_firstName = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, _metadata) {
      return Relude_Option.fold(Relude_Result.error("Required"), Relude_Result.ok, Curry._2(Relude_Option.flatMap, CommonTypes_User_Name.FirstName.fromString, Relude_String.toNonWhitespace(param.firstName)));
    })
};

var validators_email = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, _metadata) {
      var partial_arg = Relude_Result.error("Invalid Email Format");
      var partial_arg$1 = function (param) {
        return Relude_Option.fold(partial_arg, Relude_Result.ok, param);
      };
      return Relude_Option.fold(Relude_Result.error("Required"), (function (param) {
                    return Relude_Globals.$great$great(CommonTypes_Email.fromString, partial_arg$1, param);
                  }), Relude_String.toNonWhitespace(param.email));
    }),
  validateAsync: Formality__Debouncer.make(700, (function (param) {
          var dispatch = param[2];
          var value = param[0];
          var validate = function (email, param) {
            return Relude_Js_Promise.fromIO(Relude_IO.summonError(Relude_IO.flatMap((function (isAvailable) {
                                  if (isAvailable) {
                                    return Relude_IO.pure(email);
                                  } else {
                                    return Relude_IO.$$throw("Email address is already in use");
                                  }
                                }), Curry._2(Relude_IO.mapError, (function (param) {
                                      return "Could not validate this email address";
                                    }), Curry._1(param.checkIfEmailIsAvailable, email)))));
          };
          return Formality.Async.validateAsyncWithMetadata(value, param[1], validate, (function (res) {
                        return Curry._1(dispatch, {
                                    TAG: /* ApplyAsyncResultForEmailField */9,
                                    _0: value,
                                    _1: res
                                  });
                      }));
        })),
  eq: CommonTypes_Email.eq
};

var validators_city = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, _metadata) {
      return Relude_Option.fold(Relude_Result.error("Required"), Relude_Result.ok, param.city);
    })
};

var validators_businessName = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, _metadata) {
      return Relude_Option.fold(Relude_Result.error("Required"), Relude_Result.ok, Relude_String.toNonWhitespace(param.businessName));
    })
};

var validators = {
  promoCode: validators_promoCode,
  phoneNumber: validators_phoneNumber,
  password: validators_password,
  lastName: validators_lastName,
  firstName: validators_firstName,
  email: validators_email,
  city: validators_city,
  businessName: validators_businessName
};

function initialFieldsStatuses(_input) {
  return {
          promoCode: /* Pristine */0,
          phoneNumber: /* Pristine */0,
          password: /* Pristine */0,
          lastName: /* Pristine */0,
          firstName: /* Pristine */0,
          email: /* Pristine */0,
          city: /* Pristine */0,
          businessName: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.promoCode;
  var match_0 = match ? match._0 : Curry._2(validators.promoCode.validate, input, metadata);
  var value = fieldsStatuses.phoneNumber;
  var tmp;
  tmp = typeof value === "number" ? ({
        NAME: "Result",
        VAL: Curry._2(validators.phoneNumber.validate, input, metadata)
      }) : (
      value.TAG === /* Dirty */0 ? ({
            NAME: "Result",
            VAL: value._0
          }) : ({
            NAME: "Validating",
            VAL: value._0
          })
    );
  var match$1 = fieldsStatuses.password;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.password.validate, input, metadata);
  var match$2 = fieldsStatuses.lastName;
  var match_0$2 = match$2 ? match$2._0 : Curry._2(validators.lastName.validate, input, metadata);
  var match$3 = fieldsStatuses.firstName;
  var match_0$3 = match$3 ? match$3._0 : Curry._2(validators.firstName.validate, input, metadata);
  var value$1 = fieldsStatuses.email;
  var tmp$1;
  tmp$1 = typeof value$1 === "number" ? ({
        NAME: "Result",
        VAL: Curry._2(validators.email.validate, input, metadata)
      }) : (
      value$1.TAG === /* Dirty */0 ? ({
            NAME: "Result",
            VAL: value$1._0
          }) : ({
            NAME: "Validating",
            VAL: value$1._0
          })
    );
  var match$4 = fieldsStatuses.city;
  var match_0$4 = match$4 ? match$4._0 : Curry._2(validators.city.validate, input, metadata);
  var match$5 = fieldsStatuses.businessName;
  var match_0$5 = match$5 ? match$5._0 : Curry._2(validators.businessName.validate, input, metadata);
  var promoCodeResult;
  var promoCodeResultVisibility;
  var phoneNumberResult;
  var phoneNumberResultVisibility;
  var passwordResult;
  var passwordResultVisibility;
  var lastNameResult;
  var lastNameResultVisibility;
  var firstNameResult;
  var firstNameResultVisibility;
  var emailResult;
  var emailResultVisibility;
  var cityResult;
  var cityResultVisibility;
  var businessNameResult;
  var businessNameResultVisibility;
  var promoCodeResult$1 = match_0;
  var exit = 0;
  if (promoCodeResult$1.TAG === /* Ok */0) {
    var match$6 = tmp;
    if (typeof match$6 === "string" || match$6.NAME !== "Result") {
      exit = 2;
    } else {
      var phoneNumberResult$1 = match$6.VAL;
      if (phoneNumberResult$1.TAG === /* Ok */0) {
        var passwordResult$1 = match_0$1;
        if (passwordResult$1.TAG === /* Ok */0) {
          var lastNameResult$1 = match_0$2;
          if (lastNameResult$1.TAG === /* Ok */0) {
            var firstNameResult$1 = match_0$3;
            if (firstNameResult$1.TAG === /* Ok */0) {
              var match$7 = tmp$1;
              if (typeof match$7 === "string") {
                exit = 2;
              } else {
                if (match$7.NAME === "Result") {
                  var businessNameResult$1 = match_0$5;
                  var cityResult$1 = match_0$4;
                  var emailResult$1 = match$7.VAL;
                  return {
                          TAG: /* Valid */0,
                          output: {
                            businessName: businessNameResult$1._0,
                            city: cityResult$1._0,
                            email: emailResult$1._0,
                            firstName: firstNameResult$1._0,
                            lastName: lastNameResult$1._0,
                            password: passwordResult$1._0,
                            phoneNumber: phoneNumberResult$1._0,
                            promoCode: promoCodeResult$1._0
                          },
                          fieldsStatuses: {
                            promoCode: /* Dirty */{
                              _0: promoCodeResult$1,
                              _1: /* Shown */0
                            },
                            phoneNumber: {
                              TAG: /* Dirty */0,
                              _0: phoneNumberResult$1,
                              _1: /* Shown */0
                            },
                            password: /* Dirty */{
                              _0: passwordResult$1,
                              _1: /* Shown */0
                            },
                            lastName: /* Dirty */{
                              _0: lastNameResult$1,
                              _1: /* Shown */0
                            },
                            firstName: /* Dirty */{
                              _0: firstNameResult$1,
                              _1: /* Shown */0
                            },
                            email: {
                              TAG: /* Dirty */0,
                              _0: emailResult$1,
                              _1: /* Shown */0
                            },
                            city: /* Dirty */{
                              _0: cityResult$1,
                              _1: /* Shown */0
                            },
                            businessName: /* Dirty */{
                              _0: businessNameResult$1,
                              _1: /* Shown */0
                            }
                          },
                          collectionsStatuses: undefined
                        };
                }
                exit = 2;
              }
            } else {
              exit = 2;
            }
          } else {
            exit = 2;
          }
        } else {
          exit = 2;
        }
      } else {
        exit = 2;
      }
    }
  } else {
    exit = 2;
  }
  if (exit === 2) {
    var phoneNumberResult$2 = tmp;
    var exit$1 = 0;
    var exit$2 = 0;
    if (typeof phoneNumberResult$2 === "string" || phoneNumberResult$2.NAME !== "Result") {
      exit$2 = 4;
    } else {
      var match$8 = tmp$1;
      if (typeof match$8 === "string") {
        exit$2 = 4;
      } else {
        if (match$8.NAME === "Result") {
          return {
                  TAG: /* Invalid */1,
                  fieldsStatuses: {
                    promoCode: /* Dirty */{
                      _0: promoCodeResult$1,
                      _1: /* Shown */0
                    },
                    phoneNumber: {
                      TAG: /* Dirty */0,
                      _0: phoneNumberResult$2.VAL,
                      _1: /* Shown */0
                    },
                    password: /* Dirty */{
                      _0: match_0$1,
                      _1: /* Shown */0
                    },
                    lastName: /* Dirty */{
                      _0: match_0$2,
                      _1: /* Shown */0
                    },
                    firstName: /* Dirty */{
                      _0: match_0$3,
                      _1: /* Shown */0
                    },
                    email: {
                      TAG: /* Dirty */0,
                      _0: match$8.VAL,
                      _1: /* Shown */0
                    },
                    city: /* Dirty */{
                      _0: match_0$4,
                      _1: /* Shown */0
                    },
                    businessName: /* Dirty */{
                      _0: match_0$5,
                      _1: /* Shown */0
                    }
                  },
                  collectionsStatuses: undefined
                };
        }
        exit$2 = 4;
      }
    }
    if (exit$2 === 4) {
      var emailResult$2 = tmp$1;
      if (typeof emailResult$2 === "string" || emailResult$2.NAME !== "Validating") {
        exit$1 = 3;
      } else {
        promoCodeResult = promoCodeResult$1;
        promoCodeResultVisibility = /* Shown */0;
        phoneNumberResult = phoneNumberResult$2;
        phoneNumberResultVisibility = /* Shown */0;
        passwordResult = match_0$1;
        passwordResultVisibility = /* Shown */0;
        lastNameResult = match_0$2;
        lastNameResultVisibility = /* Shown */0;
        firstNameResult = match_0$3;
        firstNameResultVisibility = /* Shown */0;
        emailResult = emailResult$2;
        emailResultVisibility = /* Shown */0;
        cityResult = match_0$4;
        cityResultVisibility = /* Shown */0;
        businessNameResult = match_0$5;
        businessNameResultVisibility = /* Shown */0;
      }
    }
    if (exit$1 === 3) {
      promoCodeResult = promoCodeResult$1;
      promoCodeResultVisibility = /* Shown */0;
      phoneNumberResult = phoneNumberResult$2;
      phoneNumberResultVisibility = /* Shown */0;
      passwordResult = match_0$1;
      passwordResultVisibility = /* Shown */0;
      lastNameResult = match_0$2;
      lastNameResultVisibility = /* Shown */0;
      firstNameResult = match_0$3;
      firstNameResultVisibility = /* Shown */0;
      emailResult = tmp$1;
      emailResultVisibility = /* Shown */0;
      cityResult = match_0$4;
      cityResultVisibility = /* Shown */0;
      businessNameResult = match_0$5;
      businessNameResultVisibility = /* Shown */0;
    }
    
  }
  return {
          TAG: /* Validating */2,
          fieldsStatuses: {
            promoCode: /* Dirty */{
              _0: promoCodeResult,
              _1: promoCodeResultVisibility
            },
            phoneNumber: phoneNumberResult.NAME === "Result" ? ({
                  TAG: /* Dirty */0,
                  _0: phoneNumberResult.VAL,
                  _1: phoneNumberResultVisibility
                }) : ({
                  TAG: /* Validating */1,
                  _0: phoneNumberResult.VAL
                }),
            password: /* Dirty */{
              _0: passwordResult,
              _1: passwordResultVisibility
            },
            lastName: /* Dirty */{
              _0: lastNameResult,
              _1: lastNameResultVisibility
            },
            firstName: /* Dirty */{
              _0: firstNameResult,
              _1: firstNameResultVisibility
            },
            email: emailResult.NAME === "Result" ? ({
                  TAG: /* Dirty */0,
                  _0: emailResult.VAL,
                  _1: emailResultVisibility
                }) : ({
                  TAG: /* Validating */1,
                  _0: emailResult.VAL
                }),
            city: /* Dirty */{
              _0: cityResult,
              _1: cityResultVisibility
            },
            businessName: /* Dirty */{
              _0: businessNameResult,
              _1: businessNameResultVisibility
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurPromoCodeField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.promoCode, validators_promoCode, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  promoCode: status,
                                  phoneNumber: init.phoneNumber,
                                  password: init.password,
                                  lastName: init.lastName,
                                  firstName: init.firstName,
                                  email: init.email,
                                  city: init.city,
                                  businessName: init.businessName
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurPhoneNumberField */1 :
                  var result$1 = Formality.Async.validateFieldOnBlurWithMetadata(state.input, metadata, state.fieldsStatuses.phoneNumber, validators_phoneNumber, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  promoCode: init.promoCode,
                                  phoneNumber: status,
                                  password: init.password,
                                  lastName: init.lastName,
                                  firstName: init.firstName,
                                  email: init.email,
                                  city: init.city,
                                  businessName: init.businessName
                                };
                        }));
                  if (result$1 === undefined) {
                    return /* NoUpdate */0;
                  }
                  var value = result$1.phoneNumber;
                  if (typeof value !== "number" && value.TAG !== /* Dirty */0) {
                    var value$1 = value._0;
                    return {
                            TAG: /* UpdateWithSideEffects */1,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            },
                            _1: (function (param) {
                                return Curry._1(validators_phoneNumber.validateAsync, [
                                            value$1,
                                            metadata,
                                            param.dispatch
                                          ]);
                              })
                          };
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: result$1,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
                  break;
              case /* BlurPasswordField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.password, validators_password, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  promoCode: init.promoCode,
                                  phoneNumber: init.phoneNumber,
                                  password: status,
                                  lastName: init.lastName,
                                  firstName: init.firstName,
                                  email: init.email,
                                  city: init.city,
                                  businessName: init.businessName
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurLastNameField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.lastName, validators_lastName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  promoCode: init.promoCode,
                                  phoneNumber: init.phoneNumber,
                                  password: init.password,
                                  lastName: status,
                                  firstName: init.firstName,
                                  email: init.email,
                                  city: init.city,
                                  businessName: init.businessName
                                };
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurFirstNameField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.firstName, validators_firstName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  promoCode: init.promoCode,
                                  phoneNumber: init.phoneNumber,
                                  password: init.password,
                                  lastName: init.lastName,
                                  firstName: status,
                                  email: init.email,
                                  city: init.city,
                                  businessName: init.businessName
                                };
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurEmailField */5 :
                  var result$5 = Formality.Async.validateFieldOnBlurWithMetadata(state.input, metadata, state.fieldsStatuses.email, validators_email, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  promoCode: init.promoCode,
                                  phoneNumber: init.phoneNumber,
                                  password: init.password,
                                  lastName: init.lastName,
                                  firstName: init.firstName,
                                  email: status,
                                  city: init.city,
                                  businessName: init.businessName
                                };
                        }));
                  if (result$5 === undefined) {
                    return /* NoUpdate */0;
                  }
                  var value$2 = result$5.email;
                  if (typeof value$2 !== "number" && value$2.TAG !== /* Dirty */0) {
                    var value$3 = value$2._0;
                    return {
                            TAG: /* UpdateWithSideEffects */1,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            },
                            _1: (function (param) {
                                return Curry._1(validators_email.validateAsync, [
                                            value$3,
                                            metadata,
                                            param.dispatch
                                          ]);
                              })
                          };
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: result$5,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
                  break;
              case /* BlurCityField */6 :
                  var result$6 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.city, validators_city, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  promoCode: init.promoCode,
                                  phoneNumber: init.phoneNumber,
                                  password: init.password,
                                  lastName: init.lastName,
                                  firstName: init.firstName,
                                  email: init.email,
                                  city: status,
                                  businessName: init.businessName
                                };
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurBusinessNameField */7 :
                  var result$7 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.businessName, validators_businessName, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  promoCode: init.promoCode,
                                  phoneNumber: init.phoneNumber,
                                  password: init.password,
                                  lastName: init.lastName,
                                  firstName: init.firstName,
                                  email: init.email,
                                  city: init.city,
                                  businessName: status
                                };
                        }));
                  if (result$7 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$7,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */8 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  switch (match$1.TAG | 0) {
                    case /* Valid */0 :
                        var output = match$1.output;
                        var error = state.formStatus;
                        var tmp;
                        tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : error._0;
                        return {
                                TAG: /* UpdateWithSideEffects */1,
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: {
                                    TAG: /* Submitting */0,
                                    _0: tmp
                                  },
                                  submissionStatus: /* AttemptedToSubmit */1
                                },
                                _1: (function (param) {
                                    var dispatch = param.dispatch;
                                    return Curry._2(onSubmit, output, {
                                                notifyOnSuccess: (function (input) {
                                                    return Curry._1(dispatch, {
                                                                TAG: /* SetSubmittedStatus */10,
                                                                _0: input
                                                              });
                                                  }),
                                                notifyOnFailure: (function (error) {
                                                    return Curry._1(dispatch, {
                                                                TAG: /* SetSubmissionFailedStatus */11,
                                                                _0: error
                                                              });
                                                  }),
                                                reset: (function (param) {
                                                    return Curry._1(dispatch, /* Reset */11);
                                                  }),
                                                dismissSubmissionResult: (function (param) {
                                                    return Curry._1(dispatch, /* DismissSubmissionResult */10);
                                                  })
                                              });
                                  })
                              };
                    case /* Invalid */1 :
                        return {
                                TAG: /* Update */0,
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: /* Editing */0,
                                  submissionStatus: /* AttemptedToSubmit */1
                                }
                              };
                    case /* Validating */2 :
                        return {
                                TAG: /* Update */0,
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: state.formStatus,
                                  submissionStatus: state.submissionStatus
                                }
                              };
                    
                  }
                  break;
              case /* DismissSubmissionError */9 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */10 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */11 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdatePromoCodeField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.promoCode, state.submissionStatus, validators_promoCode, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            promoCode: status,
                                            phoneNumber: init.phoneNumber,
                                            password: init.password,
                                            lastName: init.lastName,
                                            firstName: init.firstName,
                                            email: init.email,
                                            city: init.city,
                                            businessName: init.businessName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdatePhoneNumberField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = Formality.Async.validateFieldOnChangeInOnChangeModeWithMetadata(nextInput$1, metadata, state.fieldsStatuses.phoneNumber, state.submissionStatus, validators_phoneNumber, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  promoCode: init.promoCode,
                                  phoneNumber: status,
                                  password: init.password,
                                  lastName: init.lastName,
                                  firstName: init.firstName,
                                  email: init.email,
                                  city: init.city,
                                  businessName: init.businessName
                                };
                        }));
                  var value$4 = nextFieldsStatuses.phoneNumber;
                  if (typeof value$4 !== "number" && value$4.TAG !== /* Dirty */0) {
                    var value$5 = value$4._0;
                    return {
                            TAG: /* UpdateWithSideEffects */1,
                            _0: {
                              input: nextInput$1,
                              fieldsStatuses: nextFieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            },
                            _1: (function (param) {
                                return Curry._1(validators_phoneNumber.validateAsync, [
                                            value$5,
                                            metadata,
                                            param.dispatch
                                          ]);
                              })
                          };
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: nextFieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdatePasswordField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.password, state.submissionStatus, validators_password, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            promoCode: init.promoCode,
                                            phoneNumber: init.phoneNumber,
                                            password: status,
                                            lastName: init.lastName,
                                            firstName: init.firstName,
                                            email: init.email,
                                            city: init.city,
                                            businessName: init.businessName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateLastNameField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.lastName, state.submissionStatus, validators_lastName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            promoCode: init.promoCode,
                                            phoneNumber: init.phoneNumber,
                                            password: init.password,
                                            lastName: status,
                                            firstName: init.firstName,
                                            email: init.email,
                                            city: init.city,
                                            businessName: init.businessName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateFirstNameField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$4, metadata, state.fieldsStatuses.firstName, state.submissionStatus, validators_firstName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            promoCode: init.promoCode,
                                            phoneNumber: init.phoneNumber,
                                            password: init.password,
                                            lastName: init.lastName,
                                            firstName: status,
                                            email: init.email,
                                            city: init.city,
                                            businessName: init.businessName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateEmailField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$1 = Formality.Async.validateFieldOnChangeInOnChangeModeWithMetadata(nextInput$5, metadata, state.fieldsStatuses.email, state.submissionStatus, validators_email, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  promoCode: init.promoCode,
                                  phoneNumber: init.phoneNumber,
                                  password: init.password,
                                  lastName: init.lastName,
                                  firstName: init.firstName,
                                  email: status,
                                  city: init.city,
                                  businessName: init.businessName
                                };
                        }));
                  var value$6 = nextFieldsStatuses$1.email;
                  if (typeof value$6 !== "number" && value$6.TAG !== /* Dirty */0) {
                    var value$7 = value$6._0;
                    return {
                            TAG: /* UpdateWithSideEffects */1,
                            _0: {
                              input: nextInput$5,
                              fieldsStatuses: nextFieldsStatuses$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            },
                            _1: (function (param) {
                                return Curry._1(validators_email.validateAsync, [
                                            value$7,
                                            metadata,
                                            param.dispatch
                                          ]);
                              })
                          };
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: nextFieldsStatuses$1,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCityField */6 :
                  var nextInput$6 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$6, metadata, state.fieldsStatuses.city, state.submissionStatus, validators_city, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            promoCode: init.promoCode,
                                            phoneNumber: init.phoneNumber,
                                            password: init.password,
                                            lastName: init.lastName,
                                            firstName: init.firstName,
                                            email: init.email,
                                            city: status,
                                            businessName: init.businessName
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateBusinessNameField */7 :
                  var nextInput$7 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$7,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$7, metadata, state.fieldsStatuses.businessName, state.submissionStatus, validators_businessName, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            promoCode: init.promoCode,
                                            phoneNumber: init.phoneNumber,
                                            password: init.password,
                                            lastName: init.lastName,
                                            firstName: init.firstName,
                                            email: init.email,
                                            city: init.city,
                                            businessName: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* ApplyAsyncResultForPhoneNumberField */8 :
                  var validator = validators_phoneNumber;
                  var x = state.fieldsStatuses.phoneNumber;
                  if (typeof x === "number") {
                    return /* NoUpdate */0;
                  }
                  if (x.TAG === /* Dirty */0) {
                    return /* NoUpdate */0;
                  }
                  if (!Curry._2(validator.eq, x._0, action._0)) {
                    return /* NoUpdate */0;
                  }
                  var init = state.fieldsStatuses;
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: {
                              promoCode: init.promoCode,
                              phoneNumber: {
                                TAG: /* Dirty */0,
                                _0: action._1,
                                _1: /* Shown */0
                              },
                              password: init.password,
                              lastName: init.lastName,
                              firstName: init.firstName,
                              email: init.email,
                              city: init.city,
                              businessName: init.businessName
                            },
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* ApplyAsyncResultForEmailField */9 :
                  var validator$1 = validators_email;
                  var x$1 = state.fieldsStatuses.email;
                  if (typeof x$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (x$1.TAG === /* Dirty */0) {
                    return /* NoUpdate */0;
                  }
                  if (!Curry._2(validator$1.eq, x$1._0, action._0)) {
                    return /* NoUpdate */0;
                  }
                  var init$1 = state.fieldsStatuses;
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: {
                              promoCode: init$1.promoCode,
                              phoneNumber: init$1.phoneNumber,
                              password: init$1.password,
                              lastName: init$1.lastName,
                              firstName: init$1.firstName,
                              email: {
                                TAG: /* Dirty */0,
                                _0: action._1,
                                _1: /* Shown */0
                              },
                              city: init$1.city,
                              businessName: init$1.businessName
                            },
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */10 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */11 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */12 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Curry._1(map, error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updatePromoCode: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePromoCodeField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updatePhoneNumber: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePhoneNumberField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updatePassword: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdatePasswordField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateLastName: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateLastNameField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateFirstName: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateFirstNameField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateEmail: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEmailField */5,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCity: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCityField */6,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateBusinessName: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateBusinessNameField */7,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurPromoCode: (function (param) {
              return Curry._1(dispatch, /* BlurPromoCodeField */0);
            }),
          blurPhoneNumber: (function (param) {
              return Curry._1(dispatch, /* BlurPhoneNumberField */1);
            }),
          blurPassword: (function (param) {
              return Curry._1(dispatch, /* BlurPasswordField */2);
            }),
          blurLastName: (function (param) {
              return Curry._1(dispatch, /* BlurLastNameField */3);
            }),
          blurFirstName: (function (param) {
              return Curry._1(dispatch, /* BlurFirstNameField */4);
            }),
          blurEmail: (function (param) {
              return Curry._1(dispatch, /* BlurEmailField */5);
            }),
          blurCity: (function (param) {
              return Curry._1(dispatch, /* BlurCityField */6);
            }),
          blurBusinessName: (function (param) {
              return Curry._1(dispatch, /* BlurBusinessNameField */7);
            }),
          promoCodeResult: Formality.exposeFieldResult(state.fieldsStatuses.promoCode),
          phoneNumberResult: Formality.Async.exposeFieldResult(state.fieldsStatuses.phoneNumber),
          passwordResult: Formality.exposeFieldResult(state.fieldsStatuses.password),
          lastNameResult: Formality.exposeFieldResult(state.fieldsStatuses.lastName),
          firstNameResult: Formality.exposeFieldResult(state.fieldsStatuses.firstName),
          emailResult: Formality.Async.exposeFieldResult(state.fieldsStatuses.email),
          cityResult: Formality.exposeFieldResult(state.fieldsStatuses.city),
          businessNameResult: Formality.exposeFieldResult(state.fieldsStatuses.businessName),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.promoCode || !(typeof match.phoneNumber === "number" && !(match.password || match.lastName || match.firstName || !(typeof match.email === "number" && !(match.city || match.businessName))))) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              switch (match.TAG | 0) {
                case /* Valid */0 :
                    return true;
                case /* Invalid */1 :
                    return false;
                case /* Validating */2 :
                    return ;
                
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */8);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */9);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */10);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */12,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */11);
            })
        };
}

var Internal = {
  debounceInterval: 700,
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

var FormFields = {
  Internal: Internal,
  debounceInterval: 700,
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function getFormError(param) {
  return Relude_Globals.$great$great((function (submissionError) {
                if (typeof submissionError === "number") {
                  return ;
                } else if (submissionError.TAG === /* Submitting */0) {
                  return submissionError._0;
                } else {
                  return Relude_Option.pure(submissionError._0);
                }
              }), (function (param) {
                return Relude_Option.map((function (param) {
                              return "System Error: Could not send phone number code";
                            }), param);
              }), param);
}

var formFields = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: /* [] */0
    });

var row = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.mobileMedia({
            hd: BrowserStyle.flexDirection(BrowserStyle.column),
            tl: /* [] */0
          }),
      tl: /* [] */0
    });

var equalWidthInput = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.flexBasis(BrowserStyle.zero),
        tl: /* [] */0
      }
    });

var errorMessage = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.color({
            TAG: /* Red */5,
            _0: /* Medium */2
          }),
      tl: /* [] */0
    });

var promoCodeTitle = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.textDecoration("underline"),
      tl: /* [] */0
    });

var signUpLink = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf("center"),
      tl: /* [] */0
    });

var Styles = {
  formFields: formFields,
  row: row,
  equalWidthInput: equalWidthInput,
  errorMessage: errorMessage,
  promoCodeTitle: promoCodeTitle,
  signUpLink: signUpLink
};

function WebContainers_Signup_Business_BusinessInfo$Presentation(Props) {
  var checkIfEmailIsAvailable = Props.checkIfEmailIsAvailable;
  var checkIfPhoneNumberIsAvailable = Props.checkIfPhoneNumberIsAvailable;
  var cities = Props.cities;
  var initialPromoCode = Props.initialPromoCode;
  var layout = Props.layout;
  var setView = Props.setView;
  var utmParams = Props.utmParams;
  var match = useForm({
        businessName: "",
        city: undefined,
        email: "",
        firstName: "",
        lastName: "",
        password: "",
        phoneNumber: "",
        promoCode: Relude_Option.fold("", CommonTypes_Business_PromoCode.toString, initialPromoCode)
      }, {
        checkIfEmailIsAvailable: checkIfEmailIsAvailable,
        checkIfPhoneNumberIsAvailable: checkIfPhoneNumberIsAvailable
      }, (function (param, param$1) {
          var notifyOnFailure = param$1.notifyOnFailure;
          var partial_arg = Curry._1(param$1.notifyOnSuccess, undefined);
          var partial_arg$1 = function (param) {
            return Relude_Globals.$$const(partial_arg, param);
          };
          return Relude_IO.unsafeRunAsync((function (param) {
                        return Relude_Result.fold((function (param) {
                                      return Relude_Globals.$great$great((function (param) {
                                                    return Relude_Globals.$$const(/* CouldNotNavigateToNextScreen */0, param);
                                                  }), notifyOnFailure, param);
                                    }), partial_arg$1, param);
                      }), Curry._1(setView, {
                          TAG: /* VerifyCode */1,
                          businessName: param.businessName,
                          city: param.city,
                          email: param.email,
                          firstName: param.firstName,
                          lastName: param.lastName,
                          password: param.password,
                          phoneNumber: param.phoneNumber,
                          promoCode: param.promoCode,
                          utmParams: utmParams
                        }));
        }));
  var match$1 = match.input;
  var updateBusinessName = match.updateBusinessName;
  var updateCity = match.updateCity;
  var updateEmail = match.updateEmail;
  var updateFirstName = match.updateFirstName;
  var updateLastName = match.updateLastName;
  var updatePassword = match.updatePassword;
  var updatePhoneNumber = match.updatePhoneNumber;
  var updatePromoCode = match.updatePromoCode;
  var match$2 = ReactIO.useState(function (param) {
        return Relude_Option.isSome(initialPromoCode);
      });
  var setShowPromoCodeField = match$2[1];
  var showPromoCodeField = match$2[0];
  var emailResult = Curry._2(Relude_Option.flatMap, (function (result) {
          if (result.TAG === /* Validating */0) {
            return ;
          } else {
            return Relude_Option.pure(result._0);
          }
        }), match.emailResult);
  var phoneNumberResult = Curry._2(Relude_Option.flatMap, (function (result) {
          if (result.TAG === /* Validating */0) {
            return ;
          } else {
            return Relude_Option.pure(result._0);
          }
        }), match.phoneNumberResult);
  var updateBusinessName$1 = function (businessName) {
    return Relude_IO.suspend(function (param) {
                return Curry._2(updateBusinessName, (function (input, businessName) {
                              return {
                                      businessName: businessName,
                                      city: input.city,
                                      email: input.email,
                                      firstName: input.firstName,
                                      lastName: input.lastName,
                                      password: input.password,
                                      phoneNumber: input.phoneNumber,
                                      promoCode: input.promoCode
                                    };
                            }), businessName);
              });
  };
  var updateCity$1 = function (city) {
    return Relude_IO.suspend(function (param) {
                return Curry._2(updateCity, (function (input, city) {
                              return {
                                      businessName: input.businessName,
                                      city: city,
                                      email: input.email,
                                      firstName: input.firstName,
                                      lastName: input.lastName,
                                      password: input.password,
                                      phoneNumber: input.phoneNumber,
                                      promoCode: input.promoCode
                                    };
                            }), city);
              });
  };
  var updateEmail$1 = function (email) {
    return Relude_IO.suspend(function (param) {
                return Curry._2(updateEmail, (function (input, email) {
                              return {
                                      businessName: input.businessName,
                                      city: input.city,
                                      email: email,
                                      firstName: input.firstName,
                                      lastName: input.lastName,
                                      password: input.password,
                                      phoneNumber: input.phoneNumber,
                                      promoCode: input.promoCode
                                    };
                            }), email);
              });
  };
  var updateFirstName$1 = function (firstName) {
    return Relude_IO.suspend(function (param) {
                return Curry._2(updateFirstName, (function (input, firstName) {
                              return {
                                      businessName: input.businessName,
                                      city: input.city,
                                      email: input.email,
                                      firstName: firstName,
                                      lastName: input.lastName,
                                      password: input.password,
                                      phoneNumber: input.phoneNumber,
                                      promoCode: input.promoCode
                                    };
                            }), firstName);
              });
  };
  var updateLastName$1 = function (lastName) {
    return Relude_IO.suspend(function (param) {
                return Curry._2(updateLastName, (function (input, lastName) {
                              return {
                                      businessName: input.businessName,
                                      city: input.city,
                                      email: input.email,
                                      firstName: input.firstName,
                                      lastName: lastName,
                                      password: input.password,
                                      phoneNumber: input.phoneNumber,
                                      promoCode: input.promoCode
                                    };
                            }), lastName);
              });
  };
  var updatePassword$1 = function (password) {
    return Relude_IO.suspend(function (param) {
                return Curry._2(updatePassword, (function (input, password) {
                              return {
                                      businessName: input.businessName,
                                      city: input.city,
                                      email: input.email,
                                      firstName: input.firstName,
                                      lastName: input.lastName,
                                      password: password,
                                      phoneNumber: input.phoneNumber,
                                      promoCode: input.promoCode
                                    };
                            }), password);
              });
  };
  var updatePhoneNumber$1 = function (phoneNumber) {
    return Relude_IO.suspend(function (param) {
                return Curry._2(updatePhoneNumber, (function (input, phoneNumber) {
                              return {
                                      businessName: input.businessName,
                                      city: input.city,
                                      email: input.email,
                                      firstName: input.firstName,
                                      lastName: input.lastName,
                                      password: input.password,
                                      phoneNumber: phoneNumber,
                                      promoCode: input.promoCode
                                    };
                            }), phoneNumber);
              });
  };
  var updatePromoCode$1 = function (promoCode) {
    return Relude_IO.suspend(function (param) {
                return Curry._2(updatePromoCode, (function (input, promoCode) {
                              return {
                                      businessName: input.businessName,
                                      city: input.city,
                                      email: input.email,
                                      firstName: input.firstName,
                                      lastName: input.lastName,
                                      password: input.password,
                                      phoneNumber: input.phoneNumber,
                                      promoCode: promoCode
                                    };
                            }), promoCode);
              });
  };
  var onSubmit = Relude_IO.suspend(match.submit);
  var tmp = {
    className: equalWidthInput,
    items: Relude_Array.prepend(undefined, Curry._2(Relude_Array.map, Relude_Option.pure, cities)),
    itemToDisplayString: (function (param) {
        return Relude_Option.fold("", (function (param) {
                      return param.cityName;
                    }), param);
      }),
    itemToValue: (function (param) {
        return Relude_Option.fold("-1", (function (param) {
                      return Curry._1(CommonTypes_City.Id.toString, param.id);
                    }), param);
      }),
    onBlur: Relude_IO.suspend(match.blurCity),
    onChange: (function (cityId) {
        if (cityId === "-1") {
          return updateCity$1(undefined);
        } else {
          return updateCity$1(Curry._2(Relude_Option.flatMap, (function (selectedId) {
                            return Curry._2(Relude_Array.find, (function (param) {
                                          return Curry._2(CommonTypes_City.Id.eq, selectedId, param.id);
                                        }), cities);
                          }), Curry._1(CommonTypes_City.Id.fromString, cityId)));
        }
      }),
    theme: /* DarkBackground */1,
    title: "City",
    titleIcon: {
      TAG: /* Shift */6,
      _0: /* Location */13
    },
    value: Relude_Option.fold("-1", (function (param) {
            return Curry._1(CommonTypes_City.Id.toString, param.id);
          }), match$1.city)
  };
  if (match.cityResult !== undefined) {
    tmp.validationStatus = Caml_option.valFromOption(match.cityResult);
  }
  var tmp$1 = {
    icon: {
      TAG: /* Misc */4,
      _0: /* Heart */9
    },
    theme: /* DarkBackground */1,
    title: showPromoCodeField ? "Promo Code" : "Have a promo code?"
  };
  var tmp$2 = showPromoCodeField ? undefined : Relude_Option.pure(promoCodeTitle);
  if (tmp$2 !== undefined) {
    tmp$1.className = Caml_option.valFromOption(tmp$2);
  }
  return React.createElement(WebComponents_BusinessUnauthenticatedScreen.Form.make, {
              buttonTitle: "Get Started",
              children: null,
              layout: layout,
              onSubmit: onSubmit,
              title: "Create Your Account"
            }, React.createElement(BrowserComponents_FlexColumn.make, {
                  className: formFields,
                  children: null
                }, React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(match.businessNameResult)(undefined, true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Relude_IO.suspend(match.blurBusinessName), undefined, undefined, undefined, undefined, undefined, undefined, /* DarkBackground */1, "Business Name", undefined, undefined, {
                              TAG: /* Misc */4,
                              _0: /* Briefcase */2
                            }, undefined), {
                          TAG: /* Text */7,
                          _0: {
                            onChange: updateBusinessName$1,
                            value: match$1.businessName
                          }
                        }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Medium */4
                    }), React.createElement(BrowserComponents_FlexRow.make, {
                      className: row,
                      children: null
                    }, React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(match.firstNameResult)(undefined, undefined, equalWidthInput, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Relude_IO.suspend(match.blurFirstName), undefined, undefined, undefined, undefined, undefined, undefined, /* DarkBackground */1, "First Name", undefined, undefined, {
                                  TAG: /* Navigation */5,
                                  _0: /* Profile */8
                                }, undefined), {
                              TAG: /* Text */7,
                              _0: {
                                onChange: updateFirstName$1,
                                value: match$1.firstName
                              }
                            }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* Medium */4
                        }), React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(match.lastNameResult)(undefined, undefined, equalWidthInput, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Relude_IO.suspend(match.blurLastName), undefined, undefined, undefined, undefined, undefined, undefined, /* DarkBackground */1, "Last Name", undefined, undefined, {
                                  TAG: /* Navigation */5,
                                  _0: /* Profile */8
                                }, undefined), {
                              TAG: /* Text */7,
                              _0: {
                                onChange: updateLastName$1,
                                value: match$1.lastName
                              }
                            }, undefined, undefined, undefined))), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Medium */4
                    }), React.createElement(BrowserComponents_FlexRow.make, {
                      className: row,
                      children: null
                    }, React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(phoneNumberResult)("phoneNumber", undefined, equalWidthInput, undefined, undefined, undefined, undefined, undefined, undefined, "numeric", undefined, Relude_IO.suspend(match.blurPhoneNumber), undefined, undefined, undefined, undefined, undefined, undefined, /* DarkBackground */1, "Cell Phone", undefined, undefined, {
                                  TAG: /* Shift */6,
                                  _0: /* Phone */17
                                }, undefined), {
                              TAG: /* Text */7,
                              _0: {
                                onChange: (function (param) {
                                    return Relude_Globals.$great$great(StringUtils.getNumbersOnly, updatePhoneNumber$1, param);
                                  }),
                                value: match$1.phoneNumber
                              }
                            }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* Medium */4
                        }), React.createElement(BrowserComponents_Dropdown.Native.make, tmp)), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Medium */4
                    }), React.createElement(BrowserComponents_FlexRow.make, {
                      className: row,
                      children: null
                    }, React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(emailResult)("email", undefined, equalWidthInput, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Relude_IO.suspend(match.blurEmail), undefined, undefined, undefined, undefined, undefined, undefined, /* DarkBackground */1, "Email", undefined, undefined, {
                                  TAG: /* InputField */2,
                                  _0: /* Mail */7
                                }, undefined), {
                              TAG: /* Text */7,
                              _0: {
                                onChange: updateEmail$1,
                                value: match$1.email
                              }
                            }, undefined, undefined, undefined)), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* Medium */4
                        }), React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(match.passwordResult)("newPassword", undefined, equalWidthInput, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Relude_IO.suspend(match.blurPassword), undefined, undefined, undefined, undefined, undefined, undefined, /* DarkBackground */1, "Create Password", undefined, undefined, {
                                  TAG: /* Misc */4,
                                  _0: /* Password */13
                                }, undefined), {
                              TAG: /* Password */6,
                              _0: {
                                onChange: updatePassword$1,
                                value: match$1.password
                              }
                            }, undefined, undefined, undefined))), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* XXLarge */7
                    }), React.createElement(BrowserComponents_HR.Dark.make, {}), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Large */5
                    }), React.createElement(BrowserComponents_Button.Base.make, {
                      children: React.createElement(BrowserComponents_Field.Title.make, tmp$1),
                      onClick: (function (param) {
                          return Curry._1(setShowPromoCodeField, true);
                        })
                    }), showPromoCodeField ? React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(match.promoCodeResult)(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, Relude_IO.suspend(match.blurPromoCode), undefined, undefined, "optional", undefined, undefined, undefined, /* DarkBackground */1, undefined, undefined, undefined, undefined, undefined), {
                            TAG: /* Text */7,
                            _0: {
                              onChange: updatePromoCode$1,
                              value: match$1.promoCode
                            }
                          }, undefined, undefined, undefined)) : null, React.createElement(BrowserComponents_Spacer.make, {
                      size: /* XLarge */6
                    }), React.createElement("div", undefined, React.createElement(ReactUtils.S.make, {
                          children: "By signing up you agree to our "
                        }), React.createElement("a", {
                          href: "https://www.qwick.com/terms-of-use",
                          target: "_blank"
                        }, React.createElement(ReactUtils.S.make, {
                              children: "Terms of Use"
                            })), React.createElement(ReactUtils.S.make, {
                          children: " and "
                        }), React.createElement("a", {
                          href: "https://www.qwick.com/privacy-policy",
                          target: "_blank"
                        }, React.createElement(ReactUtils.S.make, {
                              children: "Privacy Policy"
                            })), React.createElement(ReactUtils.S.make, {
                          children: ", as well as receiving shift status text messages from Qwick. Standard message and data rates apply. Message frequency varies. Reply STOP to cancel at anytime."
                        })), React.createElement(BrowserComponents_Spacer.make, {
                      size: /* Large */5
                    }), React.createElement(BrowserComponents_FlexRow.make, {
                      className: signUpLink,
                      children: null
                    }, React.createElement(BrowserComponents_Text.make, {
                          children: "Already have an account?"
                        }), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* Small */3
                        }), React.createElement("a", {
                          href: WebTypes_View.toHref({
                                TAG: /* Login */3,
                                _0: /* Business */0
                              })
                        }, React.createElement(BrowserComponents_Text.make, {
                              children: "Sign In"
                            })))), Relude_Option.fold(null, (function (error) {
                    return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* XLarge */6
                                  }), React.createElement(BrowserComponents_Text.make, {
                                    className: errorMessage,
                                    children: error
                                  }));
                  }), getFormError(match.status)));
}

var Presentation = {
  FormFields: FormFields,
  getFormError: getFormError,
  Styles: Styles,
  make: WebContainers_Signup_Business_BusinessInfo$Presentation
};

function mapStateToProps(prim) {
  
}

function mapDispatchToProps(dispatch) {
  var partial_arg = {
    setView: (function (view) {
        return Curry._2(Relude_IO.mapError, (function (prim) {
                      
                    }), Curry._1(dispatch, WebStore_Types_Action.setView({
                            TAG: /* Signup */6,
                            _0: {
                              TAG: /* Business */0,
                              _0: view
                            }
                          })));
      })
  };
  return function (param) {
    return Relude_Globals.$$const(partial_arg, param);
  };
}

function WebContainers_Signup_Business_BusinessInfo(Props) {
  var checkIfEmailIsAvailable = Props.checkIfEmailIsAvailable;
  var checkIfPhoneNumberIsAvailable = Props.checkIfPhoneNumberIsAvailable;
  var cities = Props.cities;
  var initialPromoCode = Props.initialPromoCode;
  var layout = Props.layout;
  var utmParams = Props.utmParams;
  return React.createElement(WebStore.Provider.make, {
              mapStateToProps: mapStateToProps,
              mapDispatchToProps: mapDispatchToProps,
              children: (function (param, param$1) {
                  return React.createElement(WebContainers_Signup_Business_BusinessInfo$Presentation, {
                              checkIfEmailIsAvailable: checkIfEmailIsAvailable,
                              checkIfPhoneNumberIsAvailable: checkIfPhoneNumberIsAvailable,
                              cities: cities,
                              initialPromoCode: initialPromoCode,
                              layout: layout,
                              setView: param$1.setView,
                              utmParams: utmParams
                            });
                })
            });
}

var make = WebContainers_Signup_Business_BusinessInfo;

exports.Presentation = Presentation;
exports.mapStateToProps = mapStateToProps;
exports.mapDispatchToProps = mapDispatchToProps;
exports.make = make;
/* validators Not a pure module */
